import { Type, type Static } from '@sinclair/typebox';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { messageSchema } from './message.schema';

export const SendMessageResponseSchema = Type.Object({
  object: Type.Literal('MessageSent'),
  message_id: Type.Union([Type.String(), Type.Array(Type.String()), Type.Null()], {
    description:
      'The ID of the message sent. Some providers send attachments separately from the text content, which can result in multiple sent message IDs.',
  }),
});

export const ForwardMessageResponseSchema = Type.Object({
  object: Type.Literal('MessageForwarded'),
  message_id: Type.String({
    description: 'The ID of the message created in the destination chat.',
  }),
  chat_id: Type.String({ description: 'The ID of the Chat where the message was forwarded to.' }),
});

export const ModifyMessageResponseSchema = Type.Union([messageSchema, Type.Null()]);

export const ReadMessageResponseSchema = Type.Object({
  object: Type.Literal('MessageRead'),
});

export const PinMessageResponseSchema = Type.Object({
  object: Type.Literal('MessagePinUpdated'),
});

export const GetMessagesListResponseSchema = ListResponseSchema(messageSchema);

export const GetMessageResponseSchema = messageSchema;

export const DeleteMessageResponseSchema = Type.Null();

export type SendMessageResponse = Static<typeof SendMessageResponseSchema>;
export type ForwardMessageResponse = Static<typeof ForwardMessageResponseSchema>;
export type ModifyMessageResponse = Static<typeof ModifyMessageResponseSchema>;
export type ReadMessageResponse = Static<typeof ReadMessageResponseSchema>;
export type PinMessageResponse = Static<typeof PinMessageResponseSchema>;
export type GetMessagesListResponse = Static<typeof GetMessagesListResponseSchema>;
export type GetMessageResponse = Static<typeof GetMessageResponseSchema>;
export type DeleteMessageResponse = Static<typeof DeleteMessageResponseSchema>;
